var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgRequest = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.4 86.3s-24.9.3-26.8 7l-3.5 2.4s-6.6 1.8-4.6 5.9c0 0 3.4 6.6 32.4 7.8h11.4l12.4-1.2 11.6-2.4 5.2-2.2 2.5-2.5s1.1-3.3-5.3-5.4l-3.2-2.6s-.3-6.6-26.2-6.8h-5.9z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6 105.8s-2.5-4.1 3.1-6.1c0 0 .4.1 2-1.5 0 0 10.4 2.4 16.6 2.2l-1.6 2.1s-3.2 3.5-1.3 6.4c-.1.1-8.5-.4-18.8-3.1z",
    fill: "#FFCBBD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7 95.8c3.4 1.4 5.3 2.9 5.3 4.6 0 5-17 9.1-38 9.1s-38-4.1-38-9.1c0-1.7 2-3.3 5.4-4.7M37.6 93.3c0-3.9 13.2-7 29.4-7s29.4 3.1 29.4 7",
    stroke: "#312769",
    strokeWidth: 2.105,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 98.8c14.028 0 25.4-1.97 25.4-4.4 0-2.43-11.372-4.4-25.4-4.4-14.028 0-25.4 1.97-25.4 4.4 0 2.43 11.372 4.4 25.4 4.4z",
    fill: "#5D21D2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4 78.3v13.9s2.5 2 5.1 0V78.3",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4 78.3v13.9s2.5 2 5.1 0V78.3",
    stroke: "#311D6C",
    strokeWidth: 2.105,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.9 75.9c0-15.3-16.5-27.7-36.9-27.7S30.1 60.6 30.1 75.9l.2 2.3c0 5.9 16.5 10.7 36.8 10.7 20.3 0 36.8-4.8 36.8-10.7v-2.3z",
    stroke: "#311D6C",
    strokeWidth: 2.105,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5 40.7v11s2.5 2 5.1 0v-11",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5 40.7v11s2.5 2 5.1 0v-11",
    stroke: "#311D6C",
    strokeWidth: 2.105,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 42.6c3.81 0 6.9-1.12 6.9-2.5s-3.09-2.5-6.9-2.5c-3.81 0-6.9 1.12-6.9 2.5s3.09 2.5 6.9 2.5z",
    stroke: "#311D6C",
    strokeWidth: 2.105,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 26.6s-8.6 4.2-5.7 15.7M43.5 28s-2.5 4.6-.9 9.1M76.3 56.5s4.4.6 8.7 4.2",
    stroke: "#311D6C",
    strokeWidth: 2.105,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 64s-2.5 3.7-3.3 8.6",
    stroke: "#FFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6 60.2s-1.3 1.2-3 3.8M30.3 78.6s-.4-3.6.2-6.7",
    stroke: "#311D6C",
    strokeWidth: 2.105,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8 80c-.4-.3-10.7-8.5-8.5-20.8.1-.6 0-1.3-.4-1.8s-.9-.9-1.6-1c0 0-2.5-.4-4-2.2-.6-.8-1.7-1.1-2.7-.7-.6.2-13.2 4.8-19.2 22-1.2 3.3-1.6 5.6-1.8 7 1.5.7 3.7 1.4 4.5 1.6.1-1.2.8-2.4 3.5-1.8 4.4 1.2 11 2.6 19 2.6 3.2 0 6.5-.2 10.1-.8 1-.1 1.7-.8 2-1.8.2-.7-.2-1.7-.9-2.3z",
    fill: "#FFCBBD",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRequest);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/request.a2eb0282f32fa4c01461f3e428e000bc.svg";